import { BookOpenCheck } from 'lucide-react';
import { ROUTES, USER_ROLES } from '../../utils/constants';

/** DEV_TEAM sidebar entry for MCE exact-page Interactive Books QA preview (not authoring). */
export const DEV_INTERACTIVE_BOOKS_SIDEBAR_ITEM = {
  labelKey: 'sidebar.dev.interactiveBooks',
  icon: BookOpenCheck,
  route: ROUTES.DEV_INTERACTIVE_BOOKS,
  roles: [USER_ROLES.DEV_TEAM],
  activeRoutes: [ROUTES.DEV_INTERACTIVE_BOOKS],
} as const;

export function isInteractiveBooksSidebarActive(pathname: string): boolean {
  if (pathname === ROUTES.DEV_INTERACTIVE_BOOKS) return true;
  if (pathname.startsWith(`${ROUTES.DEV_INTERACTIVE_BOOKS}/`) && !pathname.includes('/preview')) {
    return true;
  }
  return false;
}
